import React, { FC } from "react";
import { Control } from "react-hook-form";

import AutocompleteBase, { AutocompleteBaseProps } from "@/components/ui/Form/Filters/components/Autocomplete/AutocompleteBase";

import AutocompleteControlled from "./AutocompleteControlled";

export interface DynamicAutocompleteProps extends AutocompleteBaseProps {
  control?: Control<any>;
}
const Autocomplete: FC<DynamicAutocompleteProps> = (args) => {
  return <>{args?.control ? <AutocompleteControlled control={args.control} {...args} /> : <AutocompleteBase {...args} />}</>;
};
export default Autocomplete;
